import { useState, useEffect, forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  AppBar,
  Slide,
  Typography,
  Button,
  Toolbar,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import readXlsxFile from "read-excel-file";

import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BulkSendDialog = ({ open, close, templateId }) => {
  const [file, setFile] = useState(null);
  const [fields, setFields] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (file) {
      readFile();
    }
  }, [file]);

  const handleClose = () => {
    setFile(null);
    setFields([]);
    setData(null);
    close();
  };

  const handleFile = (e) => {
    setFile(e.target.files[0]);
  };

  const readFile = async () => {
    readXlsxFile(file).then((rows) => {
      if (!rows[0].includes("email")) {
        alert("No email field in the file. This is required at a minimum");
      } else {
        setFields(rows[0]);
        setData(rows);
      }
    });
  };

  const handleSend = async () => {
    const body = {templateId, data};
    const result = await request('templates/bulksend','post',body);
    if (result.success) {
        toast.success(result.message)
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Bulk Send
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={2}>
            <input
              style={{ display: "none" }}
              id="contained-button-file"
              type="file"
              onChange={handleFile}
            />
            <label htmlFor="contained-button-file">
              <Button variant="contained" color="primary" component="span">
                Upload
              </Button>
            </label>
          </Grid>
          <Grid item xs={2}>
            {file ? <Typography>{file?.name}</Typography> : null}
          </Grid>
          {fields.length > 0 ? (
            <Grid item xs={12}>
              <Typography>
                The file contains the following fields: {fields.join(", ")}
              </Typography>{" "}
            </Grid>
          ) : null}
          {fields.length > 0 ? (
            <Grid item xs={12}>
              <Button variant="outlined" onClick={handleSend}>Send</Button>
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BulkSendDialog;
